import { AdvancedFreeTrialLicenseType } from '@saas/licenseTypes'

const isOnAdvancedFreeTrial = (app, workspaceId) =>
  app.$licenseHandler
    .getWorkspaceLicenseTypes(workspaceId)
    .some(
      (license) => license.getType() === AdvancedFreeTrialLicenseType.getType()
    )

/**
 * Seats aren't charged for during the advanced free trial, so labelling roles as
 * billable or free would be misleading.
 */
const hideBillableLabelsDuringFreeTrial = (RoleType) =>
  class extends RoleType {
    showIsBillable(workspaceId) {
      return (
        !isOnAdvancedFreeTrial(this.app, workspaceId) &&
        super.showIsBillable(workspaceId)
      )
    }
  }

/**
 * Extends the already registered role types instead of the enterprise ones, so that
 * anything another plugin added to them is kept.
 */
export const registerFreeTrialAwareRoleTypes = (registry, context) => {
  Object.values(registry.getAll('roles')).forEach((roleType) => {
    registry.register(
      'roles',
      new (hideBillableLabelsDuringFreeTrial(roleType.constructor))(context)
    )
  })
}
